import { render, staticRenderFns } from "./AmrTable.vue?vue&type=template&id=60fa7755&scoped=true"
import script from "./AmrTable.vue?vue&type=script&lang=js"
export * from "./AmrTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa7755",
  null
  
)

export default component.exports